const tagsView = {
  state: {
    visitedViews: [],
    cachedViews: [],
    keepAliveRoute: [],
    activeView: null
  },
  mutations: {
    ADD_KEEP_ALIVE_ROUTE: (state, name) => {
      if (state.keepAliveRoute.some(item => item === name)) return;
      state.keepAliveRoute.push(name);
    },
    DEL_KEEP_ALIVE_ROUTE: (state, name) => {
      state.keepAliveRoute.forEach((item, index) => {
        item === name && state.keepAliveRoute.splice(index, 1);
      })
    },
    ADD_VISITED_VIEWS: (state, view) => {
      // 如果记录过的路由存在，返回.不存在,就将名字加入其中
      if (state.visitedViews.some(v => v.path === view.path)) return
      // 合并属性
      state.visitedViews.push(Object.assign({}, view, {
        title: view.name || 'no-name'
      }))
      if (!view.meta.noCache) {
        state.cachedViews.push(view.name)
      }
    },
    DEL_VISITED_VIEWS: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews.splice(i, 1)
          break
        }
      }
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews.splice(index, 1)
          break
        }
      }
    },
    DEL_OTHERS_VIEWS: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews = state.visitedViews.slice(i, i + 1)
          break
        }
      }
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews = state.cachedViews.slice(index, i + 1)
          break
        }
      }
    },
    DEL_ALL_VIEWS: (state) => {
      state.visitedViews = []
      state.cachedViews = []
    },
    Set_ACTIVE_VIEW: (state, view) => {
      state.activeView = view;
    }
  },
  actions: {
    setActiveView({ commit }, view) {
      commit('Set_ACTIVE_VIEW', view);
    },
    addKeepAliveRoute({commit}, name) {
      commit('ADD_KEEP_ALIVE_ROUTE', name);
    },
    delKeepAliveRoute({commit}, name) {
      commit('DEL_KEEP_ALIVE_ROUTE', name);
    },
    addVisitedViews({ commit }, view) {
      commit('ADD_VISITED_VIEWS', view)
    },
    delVisitedViews({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_VISITED_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    delOthersViews({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_OTHERS_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    delAllViews({ commit, state }) {
      return new Promise((resolve) => {
        commit('DEL_ALL_VIEWS')
        resolve([...state.visitedViews])
      })
    }
  }
}

export default tagsView



// WEBPACK FOOTER //
// ./src/store/modules/tagsView.js